module.exports = __webpack_public_path__ + "img/mp3.c50db102.png";